export default "__VITE_ASSET__DAe93ZI5__"